export interface ValidateTextConfig {
  textarea: HTMLTextAreaElement;
  button: HTMLElement; 
  mentionUsername?: string;
  minLength?: number;
}

export const updateButtonState = ({ 
  textarea, 
  button, 
  mentionUsername,
  minLength = 1
}: ValidateTextConfig): void => {
  let contentToCheck = textarea.value.trim();

  if (mentionUsername) {
    const mentionText = `@${mentionUsername} `;
    contentToCheck = contentToCheck.replace(mentionText, '').trim();
    
    if (textarea.value.trim() === mentionText.trim() || contentToCheck.length === 0) {
      button.setAttribute('disabled', 'disabled');
      return;
    }
  }

  if (contentToCheck.length >= minLength) {
    button.removeAttribute('disabled');
  } else {
    button.setAttribute('disabled', 'disabled');
  }
};

export default {
  updateButtonState
};